import React from 'react';
import { Typography, Box, } from '@mui/material';
import RecentActivityScreenshots from './RecentActivityScreenshots'; 

const screenshots = [
  {
    timeRange: '10:00 am - 10:10 am',
    user: 'Amit Goyal',
    task: 'UI Design',
    image: '/assets/images/carousel/carousel-01.png',
    progress: { total: 40, cursor: 20, keyboard: 40 },
  },
  {
    timeRange: '10:15 am - 10:25 am',
    user: 'Amit Goyal',
    task: 'UI Design',
    image: '/assets/images/carousel/carousel-02.png',
    progress: { total: 60, cursor: 10, keyboard: 30 },
  },
  {
    timeRange: '10:30 am - 10:40 am',
    user: 'Amit Goyal',
    task: 'UI Design',
    image: '',
    progress: { total: 70, cursor: 5, keyboard: 25 },
  },
  {
    timeRange: '10:45 am - 10:55 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '/assets/images/carousel/carousel-04.png',
    progress: { total: 30, cursor: 40, keyboard: 30 },
  },
  {
    timeRange: '11:00 am - 11:10 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '/assets/images/carousel/carousel-01.png',
    progress: { total: 80, cursor: 10, keyboard: 10 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 0, cursor: 0, keyboard: 0 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 0, cursor: 0, keyboard: 0 },
  },
];

const chunkArray = (array, size) =>
  Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
    array.slice(i * size, i * size + size)
  );

const ActivityDashboard = () => {
  const chunksOf3 = chunkArray(screenshots, 3);

 const sectionDetails = [
  {
    title: 'Morning Session',
    image: '/assets/images/avatar/avatar-group1.png',
    designation: 'Product Manager',
    linkText: 'View Report',
    linkUrl: '/screenshorts',
  },
  {
    title: 'Late Morning Session',
    image: '/assets/images/avatar/avatar1.png',
    designation: 'UI/UX Designer',
    linkText: 'View Report',
    linkUrl: '/screenshorts',
  },
  {
    title: 'Afternoon Session',
    image: '/assets/images/avatar/avatar2.png',
    designation: 'Project Manager',
    linkText: 'View Report',
    linkUrl: '/screenshorts',
  },
  {
    title: 'Salona Mishra',
    image: '/assets/images/avatar/avatar-shape1.png',
    designation: 'Project Manager',
    linkText: 'View Report',
    linkUrl: '/screenshorts',
  },
];

  return (
    <>
    
   {chunksOf3.map((chunk, index) => (
  <Box key={`three-${index}`} mb={3} sx={{
      pr: index === 0 || index === 2 ? 2 : 0,        // Padding right for 1st & 3rd
      pl: index === 1 || index === 3 ? 2 : 0,        // Padding left for 2nd & 4th
      borderRight: (index === 0 || index === 2) ? '1px solid #e0e0e0' : 'none', // Border for 1st & 3rd
    }}> 
    {/* Header with image, title, designation, and right-aligned link */}
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={3}
    >
      {/* Left: Image + Text */}
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          component="img"
          src={sectionDetails[index]?.image || '/assets/images/default.png'}
          alt={sectionDetails[index]?.title}
          sx={{ width: 40, height: 40, borderRadius: '50%' }}
        />
        <Box>
          <Typography 
            fontWeight={600}
            sx={{ fontSize: '14px', textTransform: 'capitalize', color:' #1A1F36', }}
          >
            {sectionDetails[index]?.title || `Session ${index + 1}`}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>
            {sectionDetails[index]?.designation || 'Team Member'}
          </Typography>
        </Box>
      </Box>

      {/* Right: Link */}
      {sectionDetails[index]?.linkText && sectionDetails[index]?.linkUrl && (
        <Typography
          component="a"
          href={sectionDetails[index].linkUrl}
          // target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: '14px',
            color: '#0A84FF',
            fontWeight: 500,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          {sectionDetails[index].linkText}
        </Typography>
      )}
    </Box>

    {/* Screenshot cards */}
    <RecentActivityScreenshots
      data={chunk}
      columns={3}
      showProgress={true}
      showIndexCircle={true}
    />
  </Box> 
))}  
    </>
  );
};

export default ActivityDashboard;
